export default __webpack_public_path__ + "static/media/applicationform.68d5bdc3.svg";